export default __webpack_public_path__ + "c1aed7358a5b3036e492e0b15659dd73.png";